import gql from "graphql-tag";

export const UPDATE_TEMPLATE_COSTUME_VALUE = gql`
  mutation UpdateCostumeValue(
    $filter: UniqCostumeValueFilterInput!
    $update: CostumeValueUpdateInput!
  ) {
    updateCostumeValue(filter: $filter, update: $update) {
      id
    }
  }
`;
